import React from "react";
import { Link, useNavigate } from "react-router-dom";
import bg from "../assets/images/bg-onboarding.png";
import { useAuth } from "./auth/authContext";
import _ from "lodash";

export default function HeaderStep({
  disableBack,
  setStep,
  step,
  title,
  subtitle,
  icon,
}) {
  return (
    <div className="">
      <img src={bg} alt="" className="absolute top-0 -z-50 w-full" />
      <div className="fixed left-0 right-0 top-0 z-50 bg-transparent">
        <div className="mx-auto flex w-full max-w-5xl items-center justify-between p-5">
          {!disableBack && (
            <button
              className="flex-shrink-0"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setStep((prev) => prev - 1);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          )}
          <h2 className="flex-1 text-center font-bold text-monochrome-400">
            <span className="text-monochrome-600">{step + 1}</span> dari 6
          </h2>
          {/* spacer to keep title centered */}
          <div className="w-5" />
        </div>
      </div>

      <div className="flex flex-col items-center justify-end gap-2 pt-32">
        <img src={icon} alt="account" />
        <div className="mt-3 text-center">
          <h3 className="mb-1 text-xl font-semibold">{title}</h3>
          <p className="px-4 text-xs text-monochrome-300">{subtitle}</p>
        </div>
      </div>
    </div>
  );
}
